import { Context, type Effect, type Scope } from "effect";
import type { Atom, AsyncResult } from "effect/unstable/reactivity";
import type { StationClientFailure } from "../../api/station/model.ts";
import type { WorkspaceDraft } from "./persistence-model.ts";
import type { StationRoute, StationWorkbenchSnapshot } from "./workbench-model.ts";

export class StationBrowserIo extends Context.Service<StationBrowserIo, {
  readonly route: Effect.Effect<StationRoute, StationClientFailure>;
  readonly newWorkspaceId: Effect.Effect<string, StationClientFailure>;
  readonly blank: Effect.Effect<WorkspaceDraft, StationClientFailure>;
  readonly starters: (stationId: string) => Effect.Effect<readonly WorkspaceDraft[], StationClientFailure>;
  readonly visit: (stationId: string) => Effect.Effect<void, StationClientFailure>;
  readonly redirect: (stationId: string) => Effect.Effect<void, StationClientFailure>;
  readonly alert: (message: string) => Effect.Effect<void, StationClientFailure>;
  readonly confirm: (message: string) => Effect.Effect<boolean, StationClientFailure>;
}>()("workerstation/frontend/StationBrowserIo") {}

export type StationWorkbenchAction =
  | { readonly _tag: "Open"; readonly workspaceId: string }
  | { readonly _tag: "Add" }
  | { readonly _tag: "Delete"; readonly workspaceId: string }
  | { readonly _tag: "Reorder"; readonly movedId: string; readonly targetId: string; readonly placeAfterTarget: boolean }
  | { readonly _tag: "Reload" }
  | { readonly _tag: "SaveEdit"; readonly workspaceId: string; readonly draft: WorkspaceDraft };
export interface StationWorkbenchSession {
  readonly snapshot: Atom.Atom<AsyncResult.AsyncResult<StationWorkbenchSnapshot>>;
  readonly read: Effect.Effect<StationWorkbenchSnapshot>;
  readonly start: Effect.Effect<void>;
  readonly dispatch: (action: StationWorkbenchAction) => Effect.Effect<void>;
  readonly openWorkspace: (workspaceId: string) => Effect.Effect<void>;
  readonly invalidateReload: Effect.Effect<void>;
  readonly flush: Effect.Effect<void, StationClientFailure>;
}
export class StationWorkbenchSessions extends Context.Service<StationWorkbenchSessions, {
  readonly open: Effect.Effect<StationWorkbenchSession, StationClientFailure, Scope.Scope>;
}>()("workerstation/frontend/StationWorkbenchSessions") {}
